import { makeStyles } from 'tss-react/mui';
import {
  BILLING_PAGE_GREY_10,
  BLACK_ICON,
  DARK_GREY_2,
  FORM_GREY,
  HISTOWIZ_PRIMARY_COLOR,
  SECONDARY_BLUE_2,
  TRANSPARENT_BLACK_10,
  TRANSPARENT_BLACK_20,
} from 'utilities/colors';
import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';

export const useStatusLabelStyles = makeStyles()(
  (_theme, { color, withBorder, width }) => ({
    container: {
      backgroundColor: `${color}1A`,
      color,
      fontWeight: 500,
      fontSize: '0.75rem',
      borderRadius: '0.5rem',
      width,
      height: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: withBorder ? `1px solid ${color}` : 'none',
    },
    icon: {
      marginRight: '0.5rem',
      fontSize: '0.875rem',
    },
  }),
);

export const useUpcomingBillingInfoStyles = makeStyles()(() => ({
  container: {
    marginLeft: '3.5rem',
    height: '3rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  verticalSeparator: {
    marginInline: '1rem',
    backgroundColor: TRANSPARENT_BLACK_10,
    width: '1px',
    height: '100%',
  },
  icon: {
    fontSize: '0.875rem',
    color: FORM_GREY,
    marginRight: '0.25rem',
  },
  value: {
    marginTop: '0.125rem',
    fontWeight: 500,
    letterSpacing: '0.1em',
  },
  title: {
    fontWeight: 500,
    letterSpacing: '0.1em',
    fontSize: '0.75rem',
    color: FORM_GREY,
  },
}));

export const useBillingSectionStyles = makeStyles()(() => ({
  card: {
    width: '100%',
    height: '55rem',
  },
}));

export const useCommonStyles = makeStyles()(() => ({
  noDataContainer: {
    height: '10%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noDataLabel: {
    fontSize: '1.125rem',
    fontWeight: 500,
  },
  rowWithLeftPadding: {
    paddingLeft: '5rem !important',
  },
  scrollableContainer: {
    height: 'calc(100% - 4.5rem)',
    overflowY: 'auto',
    ...VERTICAL_SCROLL_STYLE,
  },
  row: {
    backgroundColor: 'white',
    paddingInline: '1.5rem',
    alignItems: 'center',
    display: 'flex',
    borderBottom: `1px solid ${TRANSPARENT_BLACK_10}`,
    fontSize: '0.875rem',
    height: '42px',
    transition: 'filter 0.3s',
    // '&:last-child': {
    //   borderBottom: 'none',
    // },
    '&:hover': {
      cursor: 'pointer',
      filter: 'brightness(0.95)',
    },
  },
  link: {
    width: 'calc(100% - 0.75rem)',
    overflow: 'hidden',

    textDecoration: 'underline',
    color: SECONDARY_BLUE_2,
    cursor: 'pointer',
  },
  boldText: {
    fontWeight: 500,
  },
}));

export const useDropdownStyles = makeStyles()(() => ({
  menuItemRoot: {
    marginBlock: '0.5rem',
    paddingInline: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuItemSelected: {
    backgroundColor: `${BILLING_PAGE_GREY_10} !important`,
  },
  selected: {
    backgroundColor: 'red',
    color: 'green',
  },
  selectedItem: { display: 'flex', alignItems: 'center', color: BLACK_ICON },
}));

export const useBillingSectionHeaderStyles = makeStyles()(() => ({
  monthlyModeButton: {
    fontWeight: 400,
    lineHeight: '1.25rem',
    letterSpacing: '0.1em',
  },
  activeButton: {
    backgroundColor: HISTOWIZ_PRIMARY_COLOR,
  },
  nonActiveButton: {
    border: `1px solid ${TRANSPARENT_BLACK_20}`,
    color: '#1C1B1F',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingInline: '0.25rem',
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
  },
  viewTypeSelector: {
    height: '2.875rem',
    borderRadius: '6px',
    border: `1px solid ${TRANSPARENT_BLACK_10}`,
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
  },
}));

export const useViewTypeSelectorItemStyles = makeStyles()(() => ({
  icon: {
    marginRight: '0.5rem',
  },
  selectorItemWrapper: {
    borderRadius: '4px',
    backgroundColor: HISTOWIZ_PRIMARY_COLOR,
    overflow: 'hidden',
  },
  selectorItem: {
    borderRadius: '3px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100% - 3px)',
    color: DARK_GREY_2,
  },
  selectedSelectorItem: {
    position: 'relative',
    backgroundColor: 'white',
  },
  wrapper: {
    color: DARK_GREY_2,
    cursor: 'pointer',
    paddingInline: '2rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  selectedWrapper: {
    color: HISTOWIZ_PRIMARY_COLOR,
    backgroundColor: `${HISTOWIZ_PRIMARY_COLOR}1A`,
  },
}));
